export const isInsuranceEnabled = (): boolean => window.env?.APP_ENV !== 'prod-eu';
